const trackHoverIntent = (element, time) => {
    let timeoutId;
    let count = 0;

    element.addEventListener('mouseenter', (e) => {
        const target = e.currentTarget || element;
        
        if (!timeoutId) {
            timeoutId = window.setTimeout(() => {
                window.dataLayer.push({
                    'event': 'hover',
                    'gtm.element': target,
                    'gtm.elementClasses': target.classes,
                    'gtm.elementId': target.id,
                    'minHoverTime': time,
                    'hoverCount': ++count
                });

                timeoutId = null;
            }, time);
        }
    });

    element.addEventListener('mouseleave', (e) => {
        if (timeoutId) {
            window.clearTimeout(timeoutId);
            timeoutId = null;
        }
    })
} 

const initAnalyticsHoverTracking = (selector, time) => {
	if (!window.dataLayer) return;
	
    const trackedElements = [...document.querySelectorAll(selector)];
    
    if (trackedElements) {
        trackedElements.map(element => trackHoverIntent(element, time));
    }
}

export default initAnalyticsHoverTracking;
